import React, { useEffect, useState, useCallback, memo, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// Material UI
import { Grid, Typography, Icon } from '@mui/material';
// Components
import TableView from 'Components/TableView';
import { InputSearch, Button } from 'Components';
import { MenuComponent } from 'Components/Menu';
import { NotificationManager } from 'Components/Notifications';
import DirectionsMap from 'Components/Map/components/DirectionsMap';
import Checkbox from 'Components/Checkbox'
import { convertWhiteColor } from 'Core/data/Helpers'
import { useRealtimeDrivers } from 'Core/hooks';
import { PillsGroup, Select, DatePicker, TimeFrame, useTimeFrameComponent } from '@gpstrackit/gtc-react-controls';
import { TypeLayer, EnumIconSize } from '../../../../../components/Map/providers/enums'
import moment from 'moment';
import { useIntl } from "react-intl";
import { HasPermission } from "Core/security";

// Views
import UploadRoute from './components/uploadRoute';

import ModalCreateEditRoute from './components/modalCreateEditRoute'

// Styles
import './routes.scss';
// Actions
import {
  realtimeMapsRoutesSearchRoutes,
  realtimeMapsRoutesGetRoutes,
  showRoutePointsInfo,
  addPointers,
  drawGetDirections,
  setMapRoutesOptions,
  clearRedux,
  catalogLoad,

  openModalRealtimeMapsRoutesCreateEditRoute,
  openModalDeleteRoutes,
  onRefreshRoutes,
  openModalRealtimeMapsUploadRoute,
  routesEditPanelRouteGetRoute
} from 'Redux/actions';

import {
  reset as resetRouteManagerCreateEditModalMain
} from '../../../../routes/views/templates/components/createEditRouteModalMain/redux/slice';

import {
  openModalDeleteRoutePoints,
  reset as resetDeleteRoutePoint
} from '../../../../routes/views/templates/components/deleteRoutePoint/redux/slice';

import {
  reset as resetRoutesTasksSlice
} from './redux/slice';


const ROWS_PER_PAGE = 25;
const defaultColor = '8677D9';

const Routes = (props) => {
  const dispatch = useDispatch();

  const { intl, mapRef } = props;
  const { messages } = useIntl();

  //list of menus
  const routeActions = [
    messages['routes_edit'],
    messages['routes_delete']
  ];

  const routesActions = [
    messages['routes_add'],
    messages['realtimeMapsRoutes_uploadRoutes_upload']
  ];

  const rotesIsTemplate = [
    { id: "1", isTemplate: 1, label: messages['route_required_field_template'], color: "default-blue" },
    { id: "2", isTemplate: 0, label: messages['route_required_field_assgned_route'], color: "default-blue" }
  ];

  const timeFrameOptions = [
    { id: "custom", label: messages['date_custom'] },
    { id: "today", label: messages['date_today'] },
    { id: "yesterday", label: messages['date_yesterday'] },
    { id: "week", label: messages['date_this_week'] },
    { id: "lastWeek", label: messages['date_last_week'] },
    { id: "thisMonth", label: messages['date_this_month'] },
    { id: "lastMonth", label: messages['date_last_month'] },
    { id: "quarter", label: messages['date_this_quarter'] },
    { id: "lastQuarter", label: messages['date_last_quarter'] },
  ]

  const timeFrame = useTimeFrameComponent(timeFrameOptions)
  const openUploadRouteModal = useSelector(state => state.realtimeMapsRoutesModalUploadRoute.open);
  const dateformat = useSelector(state => state.securityRedux.user.dateformat);
  const drivers = useRealtimeDrivers({ trackFields: ['driverId', 'name'] });

  const loadingDeleteRoutes = useSelector(state => state.routesManagerDeleteRedux.loading);
  const loadingRoutesVar = useSelector(state => state.realtimeMapsRoutesTasksRedux.loadingRoutes);

  const loadingRoute = useSelector(state => state.routesManagerEditPanelRouteRedux?.loadingRoute);
  const loadingEta = useSelector(state => state.routesManagerEditPanelRouteEtaRoutesRedux?.loading);

  const loadingRoutes = loadingRoutesVar || loadingDeleteRoutes || loadingRoute || loadingEta;
  const routes = useSelector(state => state.realtimeMapsRoutesTasksRedux.routes);
  const filters = useSelector(state => state.realtimeMapsRoutesTasksRedux.filters);
  const restart = useSelector(state => state.realtimeMapsRoutesTasksRedux.restart);
  const route = useSelector(state => state.realtimeMapsRoutesTasksRedux.route);
  const loading = useSelector(state => state.realtimeMapsRoutesTasksRedux.loading);
  const refreshRoutes = useSelector(state => state.realtimeMapsRoutesTasksRedux.refreshRoutes);
  const user = useSelector((state) => state.securityRedux.user);

  const routeId = useSelector(state => state.realtimeMapsRoutesModalCreateEditRoute?.routeId);

  const openModalDeleteRoutePointsVar = useSelector(state => state.routesManagerDeleteRoutePoint?.open);
  const deleteAllRoutePointsResponse = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.deleteAllRoutePointsResponse);
  const erorrRoutes = useSelector(state => state.routesManagedRedux.erorrRoutes);


  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [offset, setOffset] = useState(0 * ROWS_PER_PAGE);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [itemSelected, setItemSelected] = useState(0)
  const [typeRoute, setTypeRoute] = useState([rotesIsTemplate[0]])
  const [driversSelect, setDriversSelect] = useState([])
  const [scheduledAt, setScheduledAt] = useState()

  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    dispatch(catalogLoad(["drivers"], true))

    return () => {
      // Clear any active route from the map when the routes panel unmounts
      dispatch(addPointers([]));
      dispatch(drawGetDirections(false));
      dispatch(showRoutePointsInfo(false))
      dispatch(clearRedux("ROUTES_REDUX"));
      dispatch(resetRoutesTasksSlice());
    }
  }, []);

  useEffect(() => {
    if (routes) {
      if (routes.error) {
        NotificationManager.error(
          messages['routes_error'],
          messages['error'],
          3000,
          null,
          null,
          'warning',
        );
      } else {
        const { items, total } = routes;
        if (!restart) {
          const copyData = [...data];
          const newData = copyData.concat(items);
          setData(newData);

        } else {
          setData(items || []);
          setSelectedRows([])
        }
        setTotal(total || 0);
      }
    }
  }, [routes]);

  useEffect(() => {
    if (openModalDeleteRoutePointsVar && (deleteAllRoutePointsResponse)) {
      if (erorrRoutes) {
        NotificationManager.error(
          messages['routes_error'],
          messages['error'],
          3000,
          null,
          null,
          'warning',
        );
      } else {
        NotificationManager.success(
          messages['fsmRoute_modal_delete_success'],
          messages['success'],
          3000,
          null,
          null,
          'success',
        );

      }
      dispatch(resetRouteManagerCreateEditModalMain({ deleteAllRoutePointsResponse: false, errorOnMap: null }))
      if (routeId > 0) {
        dispatch(routesEditPanelRouteGetRoute({ id: routeId }))
        dispatch(onRefreshRoutes(true))
      }
      dispatch(openModalDeleteRoutePoints({ open: false, routeId: 0 }))
      dispatch(resetDeleteRoutePoint())
    }

  }, [deleteAllRoutePointsResponse, openModalDeleteRoutePointsVar]);

  useEffect(() => {
    if (typeRoute || driversSelect) {
      searchRoutes(searchText, 0)
    }
  }, [typeRoute, driversSelect, timeFrame?.startDate, timeFrame?.endDate])

  useEffect(() => {
    if (refreshRoutes) {
      searchRoutes(searchText, 0)
      dispatch(onRefreshRoutes(false))
    }

  }, [refreshRoutes])

  const refreshData = useCallback((route, action) => {
    if (action === "update") {
      const findRoute = (r) => r?.id === route?.id;
      const indexRoute = data.findIndex(findRoute);
      if (indexRoute > -1) {
        const newData = [...data];
        newData[indexRoute] = { ...route, color: route.color && route.color.includes('#') ? route.color : `#${route.color}` };
        setData(newData);
      }
    } else if (action === "delete") {
      const newData = data.filter(d => d?.id !== route);
      setData(newData);
      setTotal(total - 1);
    } else if (action === "add") {
      const newData = [...data];
      newData.unshift(route);
      setData(newData);
      setTotal(total + 1);
    }
  });

  const searchRoutes = useCallback((newSearch, newOffset, restart = true) => {

    const conditions = []

    let fields = []
    let terms = []

    fields.push("isTemplate")
    terms.push(typeRoute[0].id == "1" ? 1 : 0)

    conditions.push({
      fields: fields,
      terms: terms,
      exact: 1
    })

    if (newSearch) {
      fields = []
      terms = []
      fields.push("title")
      terms.push(newSearch)

      conditions.push({
        fields: fields,
        terms: terms
      })

    }

    //is Assigned Route
    if (typeRoute[0].id == "2" && driversSelect?.length > 0) {

      fields = []
      terms = []
      fields.push("driverId")
      driversSelect.forEach((item) => {
        terms.push(item.driverId)
      })

      conditions.push({
        fields: fields,
        terms: terms,
        exact: 1
      })
    }

    if (typeRoute[0].id == "2") {
      conditions.push({
        range: {
          fields: ['scheduledAt'],
          GTE: moment.utc(timeFrame?.startDate).format(),
          LTE: moment.utc(timeFrame?.endDate?.seconds(59)).format(),
        }
      })
    }

    !loadingRoutes && dispatch(realtimeMapsRoutesSearchRoutes({ conditions, offset: newOffset, limit: ROWS_PER_PAGE, restart: restart }));
  });

  const onChangePage = useCallback((paramPage) => {
    if (loadingRoutes) return //prevents multiple requests
    const newOffset = (paramPage - 1) * ROWS_PER_PAGE;
    searchRoutes(searchText, newOffset, false);
    setOffset(newOffset);
    setPage(paramPage)
  });

  const onSearch = useCallback((value) => {
    setSearchText(value);

    if (window.typingTime) {
      clearTimeout(window.typingTime);
    }

    window.typingTime = setTimeout(() => {
      setData([]);
      setOffset(0);
      searchRoutes(value, 0);

      window.typingTime = null;
    }, 1000);
  });

  const addCheckedElement = (id, name, value) => {
    const checkedElements = [...selectedRows]
    const findElement = checkedElements.find((item) => item.id == id)
    if (findElement) {
      checkedElements.forEach(element => {
        if (element.id == id) {
          element.checked = value
        }
      });
    } else {
      checkedElements.push({ id: id, name: name, checked: value });
    }
    setSelectedRows([...checkedElements]);
  }

  const getValuesChecked = (id) => {
    const checkedElements = [...selectedRows]
    const findElement = checkedElements.find((item) => item.id == id)
    if (findElement) {
      return findElement.checked
    }
    return false
  }

  const getSelectedItems = () => {
    const filterChecked = selectedRows.filter((item) => item.checked == true)
    if (filterChecked && filterChecked.length > 0) return true
    return false
  }

  const deleteMultipleRoutes = () => {
    let payload = {
      open: true,
      type: "route",
      isRealtime: true,
      content: messages['routes_deleteRouteContent']
    };
    const filterChecked = selectedRows.filter((item) => item.checked == true)
    if (filterChecked.length == 1) {
      payload = {
        ...payload,
        id: filterChecked[0].id,
        rows: [{ id: filterChecked[0].id, name: filterChecked[0]?.title || filterChecked[0]?.name }],
        title: messages['routes_delete_routes_title']
      }
    } else if (filterChecked.length > 1) {
      payload = {
        ...payload,
        rows: filterChecked.map((item) => ({ ...item, name: item?.title || item?.name })),
        type: 'route_multiple',
        title: messages['routes_delete_routes_title']
      }
    }
    dispatch(openModalDeleteRoutes(payload));
  }

  const onSelectCard = (row) => {
    //get the values for this route
    dispatch(realtimeMapsRoutesGetRoutes({ id: row?.id }))
  }

  useEffect(() => {
    if (route && !loading) {
      onLoadRoute(route)
    }
  }, [loading])

  const onLoadRoute = (row) => {

    if (row?.id == itemSelected) {
      //clear Route
      setItemSelected(0)
      dispatch(addPointers([]));
      dispatch(drawGetDirections(false));
      dispatch(showRoutePointsInfo(false));
      return
    }

    dispatch(addPointers([]));
    dispatch(drawGetDirections(false));
    setItemSelected(row?.id);

    let colorToRoute = row?.color?.replace('#', '')
    colorToRoute = colorToRoute ? `#${colorToRoute}` : `#${defaultColor}`;

    dispatch(setMapRoutesOptions({
      optimizeWaypoints: row?.optimized,
      avoidTolls: row?.avoidToll,
      avoidHighways: false,
      routeModule: true,
      colorRoute: colorToRoute,
      // Pass driverId so the map can keep the driver's unit visible
      driverId: row?.driverId || null
    }));

    // TODO: The drawGetDirections is taking time for to change the value in the redux
    if (window.clearRoutes) {
      clearTimeout(window.clearRoutes)
    }

    window.clearRoutes = setTimeout(() => {

      const isRouteTracker = typeRoute[0]?.id == "2" || false

      dispatch(showRoutePointsInfo(isRouteTracker))

      const newPointers = []
      row?.points?.map((item) => {
        newPointers.push({
          ...item,
          value: item?.sequence,
          layerName: TypeLayer?.FSMRoute,
          eventName: isRouteTracker ? item?.status : 'Stop',
          //eventName: item?.typePoint,
          isRouteTracker: isRouteTracker
        })
      });


      dispatch(addPointers(newPointers));
      dispatch(drawGetDirections(true));

      window.clearRoutes = null;
    }, 300);
  }

  return (
    <div>
      <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={0}>
        <Grid item xs={8}>
          <h3 style={{ margin: 0 }}>{messages['maputilities_routemarker']}</h3>
        </Grid>
        <Grid item xs={4}>
          <div style={{ float: 'right' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Button
                onClick={() => {
                  deleteMultipleRoutes()
                }}
                disabled={!getSelectedItems()}
                tooltip={messages['menu_delete']}
                type="icon"
                icon="delete"
                style={{
                  color: !getSelectedItems() ? '#ABABAB' : '#212121'
                }}
              />

              <MenuComponent
                disabled={loadingRoutes || loading}
                options={routesActions}
                //icon={ 'add_circle'}
                icon={<Icon style={{ fontSize: 22, color: '#212121' }}>add_circle</Icon>}
                onClick={(type) => {
                  if (type === messages['routes_add']) {
                    dispatch(openModalRealtimeMapsRoutesCreateEditRoute({ open: true, isTemplate: typeRoute[0].isTemplate, isNewRoutesTracker: typeRoute[0].isTemplate ? false : true, isRoutesTracker: typeRoute[0]?.isTemplate ? false : true }));
                    dispatch(drawGetDirections(false));
                    dispatch(addPointers([]));
                  }
                  if (type === messages['routes_upload']) {

                    dispatch(openModalRealtimeMapsUploadRoute({ open: true }));
                    dispatch(drawGetDirections(false));
                    dispatch(addPointers([]));
                  }
                }}
              />

            </div>
          </div>
        </Grid>
      </Grid>

      {
        HasPermission(user, ['dapprta'], [250])
        &&
        <div style={{ width: '100%', paddingTop: 10 }}>
          <PillsGroup
            //label={"Pills group title"}
            pillSize={'full'}
            //multicolor={true}
            multiple={false}
            disabled={loadingRoutes || loading}
            options={rotesIsTemplate}
            values={typeRoute}
            color="default-blue"
            onChange={(selected) => { setTypeRoute(selected) }} />
        </div>
      }
      {
        typeRoute[0].id == "2" &&
        <div>
          <div>
            <Select
              name="driverSelect"
              textField="name"
              label={messages['fsmRoute_edit_panel_route_driver']}
              valueField="driverId"
              placeholder={messages['fsmRoute_edit_panel_route_driver']}
              isMulti={true}
              options={drivers}
              isDisabled={false}
              isLoading={loadingRoutes || loading}
              isClearable={true}
              isSearchable={true}
              showPillsOutside={true}
              value={driversSelect || []}
              onChange={(value) => {
                setDriversSelect(value);
              }} />
          </div>
          <div>

            <TimeFrame
              isRequired
              filterSwitch={false}
              {...timeFrame}
              label={messages['route_required_field_schedule_at']}
              placeholder={messages['reportsMainRT_timeFrameLabel']}
              requiredMessage={messages["required_field"]}
              //customRangeDate={30}
              maxDate={moment().add(2, 'months').toDate()}
              dateFormat={dateformat || 'Y/m/d'}
            />
          </div>
        </div>
      }
      <div style={{ paddingTop: 10 }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item xs>
            <InputSearch
              placeholder={messages['search']}
              searchText={searchText}
              onSearch={onSearch}
            />
          </Grid>
        </Grid>
        <div>
          <TableView
            data={data || []}
            loading={loadingRoutes}
            page={page}
            rowsPerPage={25}
            name="routes-list"
            topSpaceSize={242}
            infiniteScroll={true}
            viewType="list"
            messages={messages}
            itemSelector={false}
            serverSide
            onChangePage={onChangePage}
            total={total}
            moreRowsAvailable={data?.length || 0 < total}
            renderRow={(row) => {
              return (
                <div style={{ padding: '10px 15px 10px 2px' }}>
                  <div className={row?.id == itemSelected ? "routes-card routes-container-selected" : "routes-card routes-container"}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      <Grid item>
                        <Checkbox
                          id={'checked_' + row?.id}
                          value={getValuesChecked(row?.id)}
                          label={''}
                          //size={'sm'}
                          className={'route-checkbox'}
                          onChange={(checked) => {
                            addCheckedElement(row?.id, row?.title, checked);
                          }}
                        ></Checkbox>
                      </Grid>
                      <Grid item xs zeroMinWidth>
                        <Typography
                          noWrap
                          variant="subtitle1"
                          className="route-title"
                          onClick={() => onSelectCard(row)}
                        >
                          {row?.title}
                        </Typography >
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      wrap="nowrap"
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      onClick={() => onSelectCard(row)}
                      style={{ cursor: 'pointer' }}
                    >
                      <Grid item>
                        <div
                          className='route-point'
                          style={{ backgroundColor: `${convertWhiteColor(row?.color) || '#D0D3D4'}` }}
                        >{messages["routes_start"]}</div>
                      </Grid>
                      <Grid item xs zeroMinWidth>
                        <Typography noWrap variant="subtitle2" color={row?.id == itemSelected ? 'inherit' : 'textSecondary'}>
                          {row?.startPoint || ""}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      wrap="nowrap"
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      onClick={() => onSelectCard(row)}
                      style={{ cursor: 'pointer' }}
                    >
                      <Grid item style={{ paddingTop: 2 }}>
                        <div
                          className='route-point'
                          style={{ backgroundColor: `${convertWhiteColor(row?.color) || '#D0D3D4'}` }}
                        >{messages["routes_end"]}</div>
                      </Grid>
                      <Grid item xs zeroMinWidth>
                        <Typography noWrap variant="subtitle2" color={row?.id == itemSelected ? 'inherit' : 'textSecondary'}>
                          {row?.endPoint || row?.startPoint}
                        </Typography>
                      </Grid>
                    </Grid>

                    {
                      (!row?.isTemplate && row?.driverId)
                      &&
                      <Grid
                        container
                        wrap="nowrap"
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        onClick={() => onSelectCard(row)}
                        style={{ cursor: 'pointer', paddingTop: 10 }}
                      >
                        <Grid item xs={4}>
                          <Typography className="route-module-label-card-main" noWrap variant="subtitle2" color={row?.id == itemSelected ? 'inherit' : ''}>
                            {messages['route_required_field_driver']}:
                          </Typography>

                        </Grid>
                        <Grid item xs={8}>
                          <Typography noWrap variant="subtitle2" color={row?.id == itemSelected ? 'inherit' : 'textSecondary'}>
                            {row?.driver?.name}
                          </Typography>
                        </Grid>
                      </Grid>
                    }

                    {
                      (!row?.isTemplate && row?.scheduledAt)
                      &&
                      <Grid
                        container
                        wrap="nowrap"
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        onClick={() => onSelectCard(row)}
                        style={{ cursor: 'pointer' }}
                      >
                        <Grid item xs={4}>
                          <Typography className="route-module-label-card-main" noWrap variant="subtitle2" color={row?.id == itemSelected ? 'inherit' : ''}>
                            {messages['route_required_field_schedule_at']}:
                          </Typography>

                        </Grid>
                        <Grid item xs={8}>
                          <Typography noWrap variant="subtitle2" color={row?.id == itemSelected ? 'inherit' : 'textSecondary'}>
                            {row?.scheduledAt}
                          </Typography>
                        </Grid>
                      </Grid>
                    }



                    <MenuComponent
                      disabled={loadingRoutes}
                      options={routeActions}
                      icon={'more_vert'}
                      className="route-actions icon-menu-vehicle-service showInHover"
                      onClick={(type) => {
                        if (type === messages['routes_edit']) {
                          dispatch(openModalRealtimeMapsRoutesCreateEditRoute({ open: true, routeId: row?.id, isTemplate: typeRoute[0].isTemplate, isRoutesTracker: typeRoute[0]?.isTemplate ? false : true }));
                        } else if (type === messages['routes_delete']) {
                          let payload = {
                            content: messages['routes_deleteRouteContent'],
                            id: row?.id,
                            isRealtime: true,
                            open: true,
                            rows: [{ id: row?.id, name: row?.title || row?.name }],
                            title: messages['routes_delete_routes_title'],
                            type: "route"
                          };
                          dispatch(openModalDeleteRoutes(payload));
                        }
                      }}
                    />
                  </div>
                </div>
              )
            }}
          />
        </div>


        {openUploadRouteModal && <UploadRoute isRealtimeMaps={true} />}


        <div style={{ display: 'none' }}>
          <DirectionsMap messages={messages} />
        </div>

        <ModalCreateEditRoute mapRef={mapRef} />

      </div>
    </div>
  )
}

export default memo(Routes);
